module.exports = __webpack_public_path__ + "img/150h100_gluhoe.33ae86fc.svg";